import React, { memo, useRef } from 'react';
import { Button, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PasswordTextField } from '../common/passwordTextField';
import { stringConstants } from '../common/strings';
import { UpdatePasswordFormValues } from '../common/interfaces';
import { SpinnerComponent } from '../common/spinnerComponent';

interface UpdatePasswordFormProps {
    submitUpdatePassword: (data: UpdatePasswordFormValues) => void;
    fieldsErrors: FieldErrors;
    handleSubmit: UseFormMethods['handleSubmit'];
    register: UseFormMethods['register'];
    watch: UseFormMethods['watch'];
    loading: boolean;
}

export const UpdatePasswordForm = memo(({ 
    submitUpdatePassword,  
    fieldsErrors, 
    handleSubmit, 
    register,
    watch,
    loading
}: UpdatePasswordFormProps) => {
    const { t } = useTranslation();
    const password = useRef({});
    password.current = watch('password', '');

    return (
        <Grid item xs={12}>
            <form onSubmit={handleSubmit(submitUpdatePassword)}>
                <Grid container item direction='row' xs={12}>
                    <StyledPassewordHelperText>
                        {t('passwordHelperText')}
                    </StyledPassewordHelperText>
                    <PasswordTextField
                        id={stringConstants.passwordName}
                        name={stringConstants.passwordName}
                        label={t('password')}
                        errorMessage={t('passwordErrorMessage')}
                        register={register}
                        passwordFieldsErrors={fieldsErrors.password}
                        password={password}
                    />
                </Grid>
                <Grid container item direction='row' xs={12}>
                    <PasswordTextField
                        id={stringConstants.confirmPasswordName}
                        name={stringConstants.confirmPasswordName}
                        label={t('confirmPassword')}
                        errorMessage={t('confirmPasswordErrorMessage')}
                        register={register}
                        passwordFieldsErrors={fieldsErrors.confirmPassword}
                        password={password}
                    />
                </Grid>
                <Grid container item direction='row' xs={12}>
                    <UpdatePasswordButton 
                        type='submit' 
                        fullWidth
                        variant='contained'
                        disableElevation
                    >
                        {t('updatePassword')}
                        {loading && <SpinnerComponent />}
                    </UpdatePasswordButton>
                </Grid>
            </form>
        </Grid>
    );
});

const StyledPassewordHelperText = styled.div`
    font-size: 12px;
    color: #888888;
    margin-bottom: 10px;
`;

const UpdatePasswordButton = styled(Button)`
    color: #ffffff !important;
    background-color: #0083C6;
    margin-top: 20px;
`;

